module.exports = __webpack_public_path__ + "static/img/notice_step.620e8466.jpg";